'use strict';

(function () {
  var MenuToggler = $('.header__hamburger').click(function (e) {
    $(this).toggleClass('__js_isActive');
    $(this).parent().find('nav').toggleClass('__js_isActive');
    $('.header').toggleClass('__js_isActive');
  });
  $('.header--nav ul').on('click', function () {
    $('.header--nav').removeClass('__js_isActive');
    $('.header__hamburger').removeClass('__js_isActive');
    $('.header').removeClass('__js_isActive');
  });
  $('.header').on('mouseleave', function () {
    $('.header__hamburger').removeClass('__js_isActive');
    $(this).parents().find('.header--nav').removeClass('__js_isActive');
    $('.header').removeClass('__js_isActive');
  });
})();

(function () {
  $('.aside-image--hover').on('mouseenter', function () {
    if (window.innerWidth > 1210) {
      if ($(this).parents('article').index() % 2 === 0) {
        $('.left-nav').css({ opacity: 0 });
      }
    }
  });
  $('.aside-image--hover').on('mouseleave', function () {
    if (window.innerWidth > 1210) {
      if ($(this).parents('article').index() % 2 === 0) {
        $('.left-nav').css({ opacity: 1 });
      }
    }
  });
})();
